/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Action from './Action/index'
import OldAction from './OldAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions"
  
}) {
let globalFeatureFlagsIsNewGenerateLettersEnabledValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'feature_flags.is_new_generate_letters_enabled',
})
let taskResourcesValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'resources',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let globalFeatureFlagsIsNewGenerateLettersEnabledValueData1 = fromData.useDataValue({ viewPath,
context: 'global',
path: 'feature_flags.is_new_generate_letters_enabled',
})
let taskResourcesValueData1 = fromData.useDataValue({ viewPath,
context: 'task',
path: 'resources',
})
  return (<React.Fragment
>
<fromFlow.When is={globalFeatureFlagsIsNewGenerateLettersEnabledValueData}>
<div
  data-testid="Actions.List"
  data-view-path={viewPath}
 style={{'--g-1-AjnkD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(taskResourcesValueData) && taskResourcesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="action"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Action(${item?.id ?? item?._id ?? index})`}
      >
<Action
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Action(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</fromFlow.When>
<fromFlow.When is={!globalFeatureFlagsIsNewGenerateLettersEnabledValueData1}>
<div
  data-testid="Actions.List:1"
  data-view-path={viewPath}
 style={{'--g-1-AjnkD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.List1}`}
>
{Array.isArray(taskResourcesValueData1) && taskResourcesValueData1.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="action"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/OldAction(${item?.id ?? item?._id ?? index})`}
      >
<OldAction
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/OldAction(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</fromFlow.When>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }